import React from 'react';
import { Modal, Button, List, Typography } from 'antd';

interface CardTaggingConfirmationModalProps {
  open: boolean;
  cardholderNames: string[];
  onConfirm: () => void;
  onCancel?: () => void;
  isBatch?: boolean;
}

const CardTaggingConfirmationModal: React.FC<CardTaggingConfirmationModalProps> = ({
  open,
  cardholderNames,
  onConfirm,
  onCancel,
  isBatch = false,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="confirm" type="primary" onClick={onConfirm}>
          I have tagged the card{isBatch && cardholderNames.length > 1 ? 's' : ''}
        </Button>,
      ]}
      closable={!!onCancel}
      title={isBatch ? 'Tag Cardholders for Batch' : 'Tag Cardholder'}
    >
      <Typography.Paragraph>
        <strong>Instruction:</strong> Please tag this card{isBatch && cardholderNames.length > 1 ? 's' : ''} with the cardholder name before handing it over to avoid any mixup.
      </Typography.Paragraph>
      {isBatch && cardholderNames.length > 1 ? (
        <List
          size="small"
          bordered
          dataSource={cardholderNames}
          renderItem={name => <List.Item>{name}</List.Item>}
        />
      ) : (
        <Typography.Paragraph>
          <strong>Cardholder Name:</strong> {cardholderNames[0]}
        </Typography.Paragraph>
      )}
    </Modal>
  );
};

export default CardTaggingConfirmationModal; 